import clsx from 'clsx'
import React, { ReactElement } from 'react'

type Props = {
  label?: React.ReactNode
  id: string
  subtext?: React.ReactNode
  children: ReactElement // Ensure children is a valid React element
  className?: string
  required?: boolean
}

function FormGroup({
  children,
  label,
  id,
  subtext,
  className,
  required,
}: Props) {
  const subtextId = subtext ? `${id}-subtext` : undefined

  return (
    <div
      className={clsx(
        'flex flex-col gap-2 w-full text-jaa-shades-gray-2.5 focus-within:text-jaa-gray-800 active:text-jaa-gray-800',
        className
      )}
    >
      <div className='w-full flex justify-between items-center'>
        {label && (
          <label htmlFor={id} className='font-medium'>
            {label} {required && <span className='text-red-500'>*</span>}
          </label>
        )}
        {subtext && (
          <span id={subtextId} className='text-sm font-light leading-5'>
            {subtext}
          </span>
        )}
      </div>
      {React.cloneElement(children, {
        id,
        'aria-describedby': subtextId,
        'aria-required': required || undefined,
      })}
    </div>
  )
}

export default FormGroup
